module.exports = __webpack_public_path__ + "static/media/bo.ad437e9f.jpg";